"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactQuery = require("react-query");
var _reactI18next = require("react-i18next");
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _date = require("../../utils/date");
var _ReactMetadata = _interopRequireDefault(require("@micado-digital/react-metadata/ReactMetadata01"));
var _contactSection = _interopRequireDefault(require("../../components/contact-section"));
var _elementHeadline = _interopRequireDefault(require("../../components/element-headline"));
var _themeTeaser = _interopRequireDefault(require("../../components/theme-teaser"));
var _pageContext = _interopRequireDefault(require("../../context/pageContext"));
var _changeLanguage = _interopRequireDefault(require("../../utils/changeLanguage"));
var _axios = _interopRequireDefault(require("axios"));
var _moment = _interopRequireDefault(require("moment"));
var _employee = _interopRequireDefault(require("./employee"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  tags: {
    display: "flex",
    "& div": {
      marginRight: theme.spacing(1)
    },
    "& a": {
      display: "flex",
      margin: theme.spacing(0, 0.5, 0, 0),
      "& span": {
        cursor: "pointer",
        display: "block"
      }
    }
  },
  textWrapper: {
    order: 2,
    [theme.breakpoints.up("md")]: {
      order: 1
    }
  },
  teaserWrapper: {
    order: 1,
    [theme.breakpoints.up("md")]: {
      order: 2
    }
  },
  infoWrapper: {
    background: theme.palette.background.light,
    padding: theme.spacing(2.5, 2)
  },
  infoItem: {
    "& + div": {
      borderTop: "1px solid ".concat(theme.palette.divider),
      margin: theme.spacing(1, 0, 0),
      padding: theme.spacing(1, 0, 0)
    }
  },
  infoLabel: {
    ...theme.customTypography.infoLabel
  }
}));
const Info = _ref => {
  var _moment$format, _getCurrentDateTime, _moment$format2, _getCurrentDateTime2;
  let {
    date,
    place,
    periods
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  const getCurrentDateTime = periods => {
    if (!periods) return [];
    let newPeriods = periods.filter(item => {
      const {
        dateFrom,
        dateTo,
        weekdays
      } = item;
      return (0, _date.checkIfDateIsBetweenAndIsWeekday)(date, dateFrom, dateTo, weekdays);
    });
    return newPeriods.length ? newPeriods : periods;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: css.infoWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: css.infoItem
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: css.infoLabel
  }, t("site.ui.labels.date"))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 9
  }, date ? "".concat((0, _moment.default)(date).format("dddd"), ", ").concat((0, _moment.default)(date).format("LL")) : "-")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: css.infoItem
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: css.infoLabel
  }, t("site.ui.labels.start"))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 9
  }, (_moment$format = (0, _moment.default)((_getCurrentDateTime = getCurrentDateTime(periods)) === null || _getCurrentDateTime === void 0 || (_getCurrentDateTime = _getCurrentDateTime[0]) === null || _getCurrentDateTime === void 0 ? void 0 : _getCurrentDateTime.timeFrom, "HH:mm").format("LT")) !== null && _moment$format !== void 0 ? _moment$format : "-")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: css.infoItem
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: css.infoLabel
  }, t("site.ui.labels.end"))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 9
  }, (_moment$format2 = (0, _moment.default)((_getCurrentDateTime2 = getCurrentDateTime(periods)) === null || _getCurrentDateTime2 === void 0 || (_getCurrentDateTime2 = _getCurrentDateTime2[0]) === null || _getCurrentDateTime2 === void 0 ? void 0 : _getCurrentDateTime2.timeTo, "HH:mm").format("LT")) !== null && _moment$format2 !== void 0 ? _moment$format2 : "-")), place && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: css.infoItem
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: css.infoLabel
  }, t("site.ui.labels.place"))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 9
  }, place)));
};
const Tags = _ref2 => {
  let {
    tags
  } = _ref2;
  const history = (0, _reactRouterDom.useHistory)();
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  const handleClick = id => {
    history.push("/".concat(i18n.language, "/activities?tag=").concat(id));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, tags && /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: css.tags,
    my: 3
  }, tags.map(tag => {
    const {
      id,
      title
    } = tag;
    return /*#__PURE__*/_react.default.createElement(_core.Chip, {
      label: title,
      key: id,
      onClick: () => handleClick(id)
    });
  })));
};
const LayoutActivity = _ref3 => {
  var _data$data, _data$data2, _data$data3, _data$data4;
  let {
    location,
    match
  } = _ref3;
  const {
    params
  } = match;
  const {
    lang,
    pagename
  } = params;
  const {
    REACT_APP_PATH
  } = process.env;
  const [pageData, setPageData] = (0, _react.useContext)(_pageContext.default);
  const {
    i18n,
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  (0, _react.useEffect)(() => {
    var _pageData$data;
    if ((pageData === null || pageData === void 0 || (_pageData$data = pageData.data) === null || _pageData$data === void 0 || (_pageData$data = _pageData$data.meta) === null || _pageData$data === void 0 ? void 0 : _pageData$data.title) === t("site.ui.pagetitles.activities")) {
      return;
    }
    const additionalPageData = {
      ...pageData
    };
    additionalPageData.data = {
      ...pageData.data,
      meta: {
        title: t("site.ui.pagetitles.activities")
      }
    };
    setPageData(additionalPageData);
  });
  const url = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ActivityDetails.api?pagename=/").concat(lang, "/activity/").concat(pagename, "&lang=").concat(lang);
  const {
    data,
    status
  } = (0, _reactQuery.useQuery)(["activity-details", lang, pagename], () => _axios.default.get(url));
  if (status !== "success") return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  if (lang !== i18n.language) {
    (0, _changeLanguage.default)(i18n, lang);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const dateFrom = location.hash.substring(1);
  const getCurrentDateTime = times => {
    if (!times) return [];
    let newTimes = times.filter(item => {
      const {
        dateFrom: from,
        dateTo: to,
        weekdays
      } = item;
      return (0, _date.checkIfDateIsBetweenAndIsWeekday)(dateFrom, from, to, weekdays);
    });
    return newTimes.length ? newTimes : times;
  };
  const formatData = data => {
    var _getCurrentDateTime$, _getCurrentDateTime$2, _data$media;
    const timeFrom = (0, _moment.default)((_getCurrentDateTime$ = getCurrentDateTime(data === null || data === void 0 ? void 0 : data.periods)[0]) === null || _getCurrentDateTime$ === void 0 ? void 0 : _getCurrentDateTime$.timeFrom, "HH:mm");
    const timeTo = (0, _moment.default)((_getCurrentDateTime$2 = getCurrentDateTime(data === null || data === void 0 ? void 0 : data.periods)[0]) === null || _getCurrentDateTime$2 === void 0 ? void 0 : _getCurrentDateTime$2.timeTo, "HH:mm");
    return {
      teaser: {
        id: data === null || data === void 0 ? void 0 : data.id,
        media: (_data$media = data === null || data === void 0 ? void 0 : data.media) !== null && _data$media !== void 0 ? _data$media : [],
        title: data === null || data === void 0 ? void 0 : data.title,
        addition: dateFrom ? "".concat((0, _moment.default)(dateFrom).format("LL"), ", ").concat((0, _moment.default)(timeFrom).format("LT")).concat(timeTo ? " - ".concat((0, _moment.default)(timeTo).format("LT")) : "") : ""
      }
    };
  };
  const teaser = formatData(data === null || data === void 0 ? void 0 : data.data);
  const {
    email,
    employees = [],
    facility,
    periods,
    phone
  } = data === null || data === void 0 ? void 0 : data.data;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ReactMetadata.default, {
    lang: i18n.language,
    title: data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.title
  }), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(Tags, {
    tags: data === null || data === void 0 || (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.tags
  }), /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
    title: data === null || data === void 0 || (_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.title,
    component: "h1"
  }), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.textWrapper,
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "div"
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: data === null || data === void 0 || (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.description
    }
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.teaserWrapper,
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_themeTeaser.default, {
    data: teaser,
    marginY: 0,
    mediaFormat: "activity-theme-teaser",
    showBookmark: true
  })))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, !!dateFrom && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(Info, {
    date: dateFrom,
    periods: periods,
    place: facility === null || facility === void 0 ? void 0 : facility.title
  })), (email || phone) && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_contactSection.default, {
    email: email,
    phone: phone
  })))), employees.length > 0 && /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 6
  }, employees === null || employees === void 0 ? void 0 : employees.map((employee, index) => {
    const {
      firstname,
      groups,
      lastname,
      media,
      profilePicture
    } = employee;
    return /*#__PURE__*/_react.default.createElement(_core.Box, {
      key: index,
      mt: 2
    }, /*#__PURE__*/_react.default.createElement(_employee.default, {
      firstName: firstname,
      groups: groups,
      lastName: lastname,
      media: media,
      profilePicture: profilePicture
    }));
  }))));
};
var _default = exports.default = LayoutActivity;